import { treeUtil } from '@salescore/buff-common'
import type { ViewConfigSheet, ViewConfigTreeNode } from '@salescore/core'

import { findSameReferenceToChild, type ReferenceToPropertyForAddChildNodeMutation } from './findSameReferenceToChild'

const generateNewNodeName = (nodes: ViewConfigTreeNode[], originalName: string, depth = 0): string => {
  const name = depth === 0 ? originalName : `${originalName}_${depth}`
  if (nodes.map((x) => x.name).includes(name)) {
    return generateNewNodeName(nodes, originalName, depth + 1)
  }
  return name
}

// packages/common/core/src/value_objects/view_config/addViewConfigChildNode.ts に同じコードがある
export const addViewConfigChildNode = ({
  node,
  referenceToProperty,
  config,
}: {
  node: ViewConfigTreeNode
  referenceToProperty: ReferenceToPropertyForAddChildNodeMutation
  config: ViewConfigSheet
}): { tree: ViewConfigTreeNode | undefined; newNodeName: string } | undefined => {
  const { tree } = config
  if (tree === undefined) {
    // 初期化はsetRootNodeにより終わっているはず
    return
  }

  // 対象のnodeが既に同じ条件のchildをもっていればそれを返す
  const child = findSameReferenceToChild(node, referenceToProperty)
  if (child !== undefined) {
    return {
      newNodeName: child.name,
      tree: undefined,
    }
  }

  const newNodeModelName =
    referenceToProperty.modelName === node.modelName
      ? referenceToProperty.referenceTo.modelName
      : referenceToProperty.modelName
  const newNodeName = generateNewNodeName(treeUtil.flatNodes(tree), newNodeModelName)
  const newNode: ViewConfigTreeNode = {
    type: 'model',
    name: newNodeName,
    modelName: newNodeModelName,
    referenceToProperty: {
      ...referenceToProperty,
      nodeName: referenceToProperty.nodeName ?? newNodeName,
    },
  }
  const newTree = treeUtil.add(tree, node.name, newNode)
  return {
    tree: newTree,
    newNodeName: newNode.name,
  }
}
